import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { RootState } from '../root-state.model';

@Injectable()
export class SizeEffects {
  private actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);
}
